import { render, staticRenderFns } from "./stuff.vue?vue&type=template&id=0c1afb14&scoped=true&"
import script from "./stuff.vue?vue&type=script&lang=js&"
export * from "./stuff.vue?vue&type=script&lang=js&"
import style0 from "./stuff.vue?vue&type=style&index=0&id=0c1afb14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1afb14",
  null
  
)

export default component.exports